// Events for contact page

export const CONTACT_EVENT_NAMES = {
  submitContactForm: 'contact - submit contact form',
} as const;

export type CONTACT_EVENT_PROPERTIES = {
  [CONTACT_EVENT_NAMES.submitContactForm]: undefined;
};
